export default __webpack_public_path__ + "static/media/mba-boardroom.92c080c7.jpg";